<template>
  <div>
    <!-- <v-row>
      <v-col cols="12">
        <p class="default-title font-weight-bold mb-3">Terms and Conditions</p>
        <div class="terms-section">
          <p>(1) I have read and accepted the terms of use.</p>
          <p>(2) I have read and understood the supporting campaign deliverables and will stay committed to the travel dates of the trip and campaign requirements.</p>
            <p class="first-inner">(i) Any additional days of trip will incur additional costs by you.</p>
            <p class="first-inner">(ii) In any case where there is a cancellation by you, all fees incurred for the trip will be paid by you.</p>
          <p>(3) I will not liaise with the Brand or the PR company, production company or any other agency involved in this campaign. directly without consulting Kobe Global Technologies Pte Ltd for the duration of this campaign, and for the three months directly following job completion. If the Brand contacts me in this period for this campaign, I am under obligation to refer the client to Kobe Global Technologies Pte Ltd.</p>
          <p>(4) I understand that the payout for this campaign is SGD 12,000 and this is agreed upon before the commencement of the job and cannot be negotiated in any terms upon my endorsement of this document.</p>
          <p class="first-inner">(i) Payment terms:</p>
            <ul class="second-inner">
              <li>Kobe shall pay 50% of fees by bank transfer on 15 May, after Content Creator’s work done on 3 May.</li>
              <li>Kobe shall pay the remaining 50% of fees by bank transfer between thirty (30) and forty-five (45) days after submission of payout with post statistics and live links on https://app.getkobe.com/. Content Creator must provide all applicable personal and bank account information after receiving the live URL link of your posting upon approval by the client.</li>
            </ul>
          <p>(5) I understand there will be fluctuation in the exchange rate in the time of transaction.</p>
          <p>(6) I understand that the requirements of shoot may change and are still being finalised.</p>
          <p>(7) I will submit all my post statistics on Kobe's portal via https://app.getkobe.com/ 7 days after posting upon client’s approvals. Remaining 50% of the agreed SGD 12,000 payout will be received within 30-45 days after stats submission on Kobe's portal and/or payment clearance from client, whichever earlier.</p>
          <p>(8) Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested timeline/guidelines from the client. I will ensure the post goes live by the approved date discussed.</p>
          <p>(9) I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months or such greater term as specified in the Campaign Agreement.</p>
          <p>(10) I own all of the content and information I create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content). You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.</p>
          <p>(11) I reserve the right to refuse posting the Music Video on my channel if any significant change of script or outcome violates Youtube's policy without prior agreement with me.</p>
          <p>(12) I have the right to decline shooting scenes that are not discussed beforehand and deemed inappropriate for the talent.</p>
          <p>(13) Party B will not be directly promoted for the Client's product featured in the Video, as agreed upon with Party A.</p>
          <p>(14) Party A and the Client will not air any materials without the review and confirmation of Party B on the final materials, including but not limited to Music Videos, Key Visuals, Digital Materials, etc.</p>
          <p>(15) Party A and the Client do not have the right to use Party B's Talent Image for any other purpose not specified in this contract. Any further requests shall be considered a new project, and the terms and conditions shall be discussed at that time.</p>
          <p>(16) Party A and the Client shall not use Party B's Talent Image to promote anything other than the deliverables agreed upon in this Contract.</p>
          <p>(17) Any misuse of Party B's Talent Image during this shoot and beyond, for any purpose not agreed upon, will result in legal charges and compensation charges by Party B.</p>
        </div>
      </v-col>
    </v-row> -->
  </div>
</template>
<script>
export default {
  name: 'TermsAndConditions'
}
</script>

<style scoped>
  .default-title {
    font-size: 18px;
  }
  
  .terms-section p {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 500;
  }

  .terms-section p.first-inner {
    padding-left: 3%;
  }

  .terms-section .second-inner {
    padding-left: 6%;
  }

  .terms-section ul li {
    list-style: disc;
    font-size: 16px;
    font-size: 16px;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// TermsAndConditions.vue?bc47e14c